// removed by extract-text-webpack-plugin
module.exports = {"pitch":"#282c31","thunder":"#6b6e72","snow":"#fafbfc","eclipse":"#9e9fa5","polarBear":"#f2f3f5","link":"GroupAspectTabs__link___34IIb","activeLink":"GroupAspectTabs__activeLink___3-eWL","inviteButton":"GroupAspectTabs__inviteButton___3syVq","pdfDrawer":"GroupAspectTabs__pdfDrawer___2Dsvf","pdfDrawerContent":"GroupAspectTabs__pdfDrawerContent___2aLsb"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/GroupAspectTabs.css
// module id = 2271
// module chunks = 0 1